import './account.css';
import { Outlet } from 'react-router-dom';

const Account = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default Account;
